// 多币种切换：USD / EUR（仅产品详情页）
// AED 为店铺本位币，已由 product-price 原生显示，这里不再重复展示
// 汇率由老板指定（2026-09-09）：1 USD = 3.6 AED，1 EUR = 4.0 AED
// 如需调整，改下面 RATES 的 3.6 / 4.0 即可（1 AED 兑换的目标币种数量）
(function () {
  var RATES = { USD: 1 / 3.6, EUR: 1 / 4.0 };
  var SYMBOLS = { USD: '$', EUR: '€' };
  var current = null;
  var wrap = document.querySelector('.product__price');
  var valEl = document.getElementById('xbCurrencyValue');

  function getAED() {
    if (!wrap) return null;
    var sel = wrap.querySelector('.price__sale .price-item--sale')
          || wrap.querySelector('.price-item--sale')
          || wrap.querySelector('.price-item--regular')
          || wrap;
    var t = (sel && sel.textContent) || '';
    var m = t.match(/[\d][\d.,]*\d/);
    return m ? parseFloat(m[0].replace(/,/g, '')) : null;
  }

  function fmt(n) {
    return Math.round(n).toLocaleString('en-US');
  }

  function render() {
    if (!valEl) return;
    if (!current) { valEl.textContent = ''; valEl.style.display = 'none'; return; }
    var aed = getAED();
    if (aed == null) { valEl.textContent = ''; valEl.style.display = 'none'; return; }
    var v = aed * RATES[current];
    valEl.textContent = SYMBOLS[current] + fmt(v);
    valEl.style.display = '';
  }

  function bind() {
    var btns = document.querySelectorAll('.xb-cur-btn');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        current = b.getAttribute('data-cur');
        btns.forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        render();
      });
    });
    if (wrap) {
      var lock = false;
      var obs = new MutationObserver(function () {
        if (lock) return;
        lock = true;
        render();
        lock = false;
      });
      obs.observe(wrap, { childList: true, subtree: true, characterData: true });
    }
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();